import { Component,OnDestroy, OnInit  } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventService } from 'src/app/services/event.service';
import { environment } from 'src/environments/environment';
import { PrivacyDialogComponent } from '../privacy-dialog/privacy-dialog/privacy-dialog.component';
import { TermsDialogComponent } from '../terms-and-conditions/terms-dialog/terms-dialog.component';
import { FvrZeropaySupportPopupService } from '../zeropay-support/fvr-zeropay-support-popup.service';

@Component({
  selector: 'app-shopper-faq',
  templateUrl: './shopper-faq.component.html',
  styleUrls: ['./shopper-faq.component.scss']
})
export class ShopperFaqComponent implements  OnInit, OnDestroy   {
  public applyRedirect = environment.applyRedirect;
  public portalRedirect = environment.portalRedirect;

  constructor(
    private matDialog: MatDialog,
    private supportService: FvrZeropaySupportPopupService,
    private eventService : EventService
  ) {}

  ngOnInit(): void {
    this.eventService.howItWorksHide();
    this.eventService.mobileDisplayLogoToolbar.next(true);
  }

  showTerms() {
    this.matDialog.open(TermsDialogComponent, {
      width: '100%',
    });
  }

  showPrivacy() {
    this.matDialog.open(PrivacyDialogComponent, {
      width: '100%',
    });
  }

  showContact() {
    this.supportService.showContactDialog();
  }

  ngOnDestroy(): void {
    this.eventService.howItWorksShow();
  }
}
